import { Button } from '@/shared/components/shadcn/button';
import { Play } from 'lucide-react';

import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import type { CampaignAnalysisReportUsage } from '../helpers/analysis-report-usage';
import { CampaignAnalysisReportUsageIndicator } from './campaign-analysis-report-usage';

type Props = {
  disabledReason?: string;
  onStartAnalysis: () => void;
  reportUsage?: CampaignAnalysisReportUsage;
  usagePlacement?: 'inline' | 'below';
};

export function CampaignAnalysisStartButton({
  disabledReason,
  onStartAnalysis,
  reportUsage,
  usagePlacement = 'inline',
}: Props) {
  const button = (
    <Button disabled={disabledReason != null} onClick={onStartAnalysis} type="button">
      <Play aria-hidden="true" data-icon="inline-start" />
      Start analysis
    </Button>
  );
  const buttonWithTooltip = disabledReason ? (
    <TooltipFlat asChild content={disabledReason} contentClassName="max-w-72 text-sm leading-5">
      <span aria-label={disabledReason} className="inline-flex" tabIndex={0}>
        {button}
      </span>
    </TooltipFlat>
  ) : (
    button
  );

  if (usagePlacement === 'below') {
    return (
      <div className="flex flex-col items-center gap-6">
        {buttonWithTooltip}
        {reportUsage ? <CampaignAnalysisReportUsageIndicator usage={reportUsage} /> : null}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-4 lg:justify-end">
      {reportUsage ? <CampaignAnalysisReportUsageIndicator usage={reportUsage} /> : null}
      {buttonWithTooltip}
    </div>
  );
}
